import { tw } from "@careinfo/tailwind";
import { ColumnDef } from "@tanstack/react-table";
import { useState } from "react";
import OutLineButton from "../../components/Reusable/OutlineButton";
import APIS from "../../constant/Endpoint";
import { DeleteIcon } from "../../Icons/DeleteIcon";
import EditIcon from "../../Icons/EditIcon";
import { formatAmount } from "../../utils/formatAmount";
import LedgerGroupForm from "../Forms/LedgerGroupForm";
import Button from "../Reusable/Button";
import DataTable from "../Reusable/Datatable";
import TableSearch from "../Reusable/Datatable/components/Search";
import NACell from "../Reusable/Datatable/NACell";
import PopupModal from "../Reusable/Modal";
import CreateAccount from "./CreateAccount";
import EditAccount from "./EditAccount";
import { AccessControl } from "@careinfo/permission-required";

const AccountInfoList = (props: any) => {
  const { handleDelete } = props;
  const [openLedgerformPopup, setOpenLedgerformPopup] = useState(false);
  const [openAccountPopup, setOpenAccountPopup] = useState(false);
  const [openEditAccountPopup, setOpenEditAccountPopup] = useState(false);
  const [accountId, setAccountId] = useState(null);
  const columns: ColumnDef<any, any>[] = [
    {
      accessorKey: "name",
      header: "Ledger Name",
      cell: NACell,
    },
    {
      accessorKey: "parent.name",
      header: "Account Type",
      cell: NACell,
    },
    {
      accessorKey: "opening_balance",
      header: "Opening Balance",
      cell: ({ row, getValue }: any) => <p>{formatAmount(getValue())}</p>,
    },
    {
      accessorKey: "address",
      header: "Company Address",
      cell: NACell,
    },
    {
      accessorKey: "contact_number",
      header: "Contact No.",
      cell: NACell,
    },
    {
      accessorKey: "vat_pan",
      header: "VAT/PAN No.",
      cell: NACell,
    },
    {
      accessorKey: "id",
      header: "Action",
      cell: ({ row, getValue }: any) => {
        return (
          <div className={tw`grid grid-cols-2 gap-x-4 items-center`}>
            <AccessControl allowedPermissions={["can_edit_account"]}>
              <button
                type="button"
                onClick={() => {
                  setAccountId(getValue()),
                    setOpenEditAccountPopup(!openEditAccountPopup);
                }}
                className={tw`focus:outline-none`}
              >
                <EditIcon color={"var(--primary)"} />
              </button>
            </AccessControl>
            {/* <AccessControl allowedPermissions={["can_delete_account"]}> */}
            <button
              type="button"
              className={tw`focus:outline-none w-6 h-6`}
              onClick={() => handleDelete(getValue())}
            >
              <DeleteIcon color={"var(--primary)"} />
            </button>
            {/* </AccessControl> */}
          </div>
        );
      },
    },
  ];

  return (
    <div className={tw`space-y-4`}>
      <div className={tw` flex gap-x-2`}>
        <AccessControl allowedPermissions={["can_search_account"]}>
          <TableSearch />
        </AccessControl>
        <div className={tw`w-32`}>
          <AccessControl allowedPermissions={["can_add_account"]}>
            <Button
              label="Add New Account"
              onClick={() => setOpenAccountPopup(!openAccountPopup)}
              type="button"
            />
          </AccessControl>
        </div>
        <AccessControl allowedPermissions={["can_add_ledger"]}>
          <OutLineButton
            onClick={() => setOpenLedgerformPopup(!openLedgerformPopup)}
            label="Ledger Group"
          />
        </AccessControl>
      </div>
      <DataTable
        columns={columns}
        queryKey={"account-info"}
        url={APIS.COA}
        params={{
          is_group: false,
        }}
        customSearch={true}
        tableName={"account-info"}
      />
      <PopupModal
        isOpen={openAccountPopup}
        setIsOpen={setOpenAccountPopup}
        title="Create Account"
      >
        <div className={tw`max-w-2xl`}>
          <CreateAccount setOpenAccountPopup={setOpenAccountPopup} />
        </div>
      </PopupModal>
      <PopupModal
        isOpen={openEditAccountPopup}
        setIsOpen={setOpenEditAccountPopup}
        title="Edit Account"
      >
        <div className={tw`max-w-2xl`}>
          <EditAccount
            id={accountId}
            setOpenEditAccountPopup={setOpenEditAccountPopup}
          />
        </div>
      </PopupModal>
      <PopupModal
        isOpen={openLedgerformPopup}
        setIsOpen={setOpenLedgerformPopup}
        title="Ledger Group"
      >
        <div className={tw`w-[400px]`}>
          <LedgerGroupForm setOpenLedgerformPopup={setOpenLedgerformPopup} />
        </div>
      </PopupModal>
    </div>
  );
};

export default AccountInfoList;
